import React from 'react';

const Footer = () => (
    <footer className="site-footer">
        {/* Footer */}
    </footer>
);

export default Footer;
